import isObject from './isObject';
import mutateItem, { STRIP_RETURN_CHARS, TO_LOWER_CASE } from './mutateItem';

const mutateObject = (obj, fn) => {
	Object.entries(obj).forEach(([key, value]) => {
		if (isObject(value)) {
			mutateObject(value, fn);
		} else if (Array.isArray(value)) {
			value.forEach((item, index) => {
				if (typeof item === 'string') {
					// eslint-disable-next-line no-param-reassign
					value[index] = fn(item);
				} else {
					mutateObject(item, fn);
				}
			});
		} else if (typeof value === 'string') {
			// eslint-disable-next-line no-param-reassign
			obj[key] = fn(value);
		}
	});
};

/**
 *
 * @param {Object} obj The object whose values you wish to mutate
 * @param {*} fn A function which will process the value and do something to it
 * @returns
 */
const objectMutator = (obj, fn) => {
	const mutatedReplacement = JSON.parse(JSON.stringify(obj));
	mutateObject(mutatedReplacement, fn);
	return mutatedReplacement;
};

export const stripAndLowerCaseObjectValues = (obj) => {
	return objectMutator(
		obj,
		mutateItem.bind(undefined, [TO_LOWER_CASE, STRIP_RETURN_CHARS])
	);
};

export default objectMutator;
